export const accountStoreActions = self => ({   
  set(key, value) {
    self[key] = value
  }
})